<template>
    <div>
        <div class="body-card-border-primary cursor-not-allowed">
            <b-overlay :show="showOverlay" rounded="sm">
                <form v-on:submit.prevent="" :class="{ 'disabled-form': !isEditingPersonnelData }">
                    <div class="row my-2">
                        <!-- Personnel data section -->
                        <h3>Datos personales
                            <b-icon-pencil class="pointer text-color-primary custom-pencil-icon margin-bottom-half" v-on:click="handlePersonnelDataForm()" v-if="!isEditingPersonnelData"/>
                            <b-icon-x-lg class="pointer text-color-primary custom-pencil-icon margin-bottom-half" v-on:click="handlePersonnelDataForm()" v-if="isEditingPersonnelData"/>
                        </h3>

                        <div class="col-sm-4 mt-2">
                            <label id="name" class="control-label">Nombre</label>

                            <input 
                                type="text"
                                class="form-control"
                                :class="[nameRequired ? 'is-invalid' : '']"
                                placeholder="Ingresá el Nombre"
                                maxlength="100"
                                v-model="userData.data.name">
                            <small v-if="nameRequired">Es un campo requerido</small>
                        </div>

                        <div class="col-sm-4 mt-2">
                            <label id="lastName" class="control-label">Apellido</label>

                            <input 
                                type="text"
                                class="form-control"
                                :class="[lastNameRequired ? 'is-invalid' : '']"
                                placeholder="Ingresá el Apellido"
                                v-model="userData.data.lastName">
                            <small v-if="lastNameRequired">Es un campo requerido</small>
                        </div>

                        <div class="col-sm-4 mt-2">
                            <label id="gender" class="control-label">Sexo</label>

                            <b-form-select v-model="genderSelected" class="form-control">
                                <b-form-select-option :value="null" disabled>Seleccioná una opción</b-form-select-option>
                                <b-form-select-option v-for="gender in genders" :key="gender.id" :value=gender.id>
                                    {{ gender.name }}
                                </b-form-select-option>
                            </b-form-select>
                        </div>

                        <div class="col-sm-4 mt-2">
                            <label id="country" class="control-label">País</label>

                            <b-form-select v-model="countrySelected" class="form-control">
                                <b-form-select-option :value="null" disabled>Seleccioná una opción</b-form-select-option>
                                <b-form-select-option v-for="country in countries" :key="country.id" :value=country.id>
                                    {{ country.name }}
                                </b-form-select-option>
                            </b-form-select>
                        </div>
                    </div>
    <!-- 
                    <div class="row my-2">
                        <div class="col-sm-3">
                            <label id="documentType" class="control-label">Tipo de Documento</label>

                            <b-form-select v-model="documentTypeSelected" class="form-control">
                                <b-form-select-option :value="null" disabled>Seleccioná una opción</b-form-select-option>
                                <b-form-select-option v-for="documentType in documentTypes" :key="documentType.id" :value=documentType.id>
                                    {{ documentType.description }}
                                </b-form-select-option>
                            </b-form-select>
                        </div>

                        <div class="col-sm-4">
                            <label id="documentNumber" class="control-label">Número de Documento</label>

                            <input 
                                type="text"
                                class="form-control"
                                :class="[documentRequired ? 'is-invalid' : '']"
                                placeholder="Ingresá el Nro. de Documento"
                                maxlength="15"
                                v-model="userData.data.documentNumber">
                            <small v-if="documentRequired">Es un campo requerido</small>
                        </div>
                    </div> -->
                </form>

                <form v-on:submit.prevent="" :class="{ 'disabled-form': !isEditingContactData }">
                    <!-- Contact data section -->
                    <div class="row my-2 mt-3">
                        <h3>Datos de contacto
                            <b-icon-pencil class="pointer text-color-primary custom-pencil-icon margin-bottom-half" v-on:click="handleContactDataForm()" v-if="!isEditingContactData"/>
                            <b-icon-x-lg class="pointer text-color-primary custom-pencil-icon margin-bottom-half" v-on:click="handleContactDataForm()" v-if="isEditingContactData"/>
                        </h3>

                        <div class="col-sm-6 mt-2">
                            <label id="documentNumber" class="control-label">Email</label>

                            <input 
                                type="text"
                                class="form-control"
                                :class="{
                                    'is-invalid': emailRequired,
                                    'input-with-icon-valid': isEmailValid,
                                    'input-with-icon-invalid': !isEmailValid && !emailRequired
                                }"
                                disabled
                                placeholder="Ingresá el Email"
                                maxlength="30"
                                v-model="userData.data.email">
                            <small v-if="emailRequired">Es un campo requerido</small>
                        </div>

                        <div class="col-sm-6 mt-2">
                            <label id="documentNumber" class="control-label">Celular</label>

                            <input 
                                type="text"
                                class="form-control"
                                :class="[phoneRequired ? 'is-invalid' : '']"
                                placeholder="Ingresá el Nro. de Celular"
                                maxlength="30"
                                v-model="userData.data.cellPhone">
                            <small v-if="phoneRequired">Es un campo requerido</small>
                        </div>

                        
                    </div>
                </form>

                <div class="row my-2 mt-2">
                    <div class="col-sm-6">
                        <label id="documentNumber" class="control-label">Contraseña</label>

                        <input type="password"
                                    :class="[errorPasswordRequired || invalidPassword ? 'is-invalid' : '', 'form-control input-border-shadow']"
                                    minlength="6"
                                    maxlength="16"
                                    placeholder="Ingresá tu Contraseña"
                                    v-model="userData.data.password"
                                    :disabled="!isEditing">

                        <small class="margin-bottom" v-if="errorPasswordRequired">Es un campo requerido</small>
                        <small class="margin-bottom" v-if="!errorPasswordRequired && invalidPassword">La longitud debe ser igual o mayor a 6</small>
                    </div>

                    <div class="row p-0 mt-2">
                        <div class="pull-right p-0">
                            <button 
                                class="btn-primary"
                                v-on:click="updateUser()"
                                :disabled="!isEditingPersonnelData && !isEditingContactData || userData.data.password === undefined">Enviar</button>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </div>
    </div>
</template>

<script>
import "@/assets/style.css"
import { mapGetters, mapActions } from "vuex"
import { GENDER_TYPES } from '@/enums/enums';
import API_ROUTES from '@/api/routes';

export default {
    name: "MyData",

    data() {
        return {
            showOverlay: false,
            isEditingPersonnelData: false,
            isEditingContactData: false,
            isEditing: false,
            isEmailValid: false,

            genders: GENDER_TYPES,
            genderSelected: null,

            countries: [],
            countrySelected: null,

            nameRequired: false,
            lastNameRequired: false,
            documentRequired: false,
            emailRequired: false,
            phoneRequired: false,
            errorPasswordRequired: false,

            invalidPassword: false,
        }
    },

    async created() { 
        await this.getCountries();

        this.genderSelected = this.userData.data.genderId;
        this.countrySelected = this.userData.data.countryId;
        this.isEmailValid = true;
    },

    methods: {
        ellipsis(name) {
            return name.length > 29 ? name.substring(0, 29) + "..." : name
        },

        handlePersonnelDataForm() {
            this.isEditingPersonnelData = !this.isEditingPersonnelData;

            if (this.isEditingPersonnelData || this.isEditingContactData) {
                this.isEditing = true;
            } else {
                this.isEditing = false;
            }
        },

        handleContactDataForm() {
            this.isEditingContactData = !this.isEditingContactData;

            if (this.isEditingPersonnelData || this.isEditingContactData) {
                this.isEditing = true;
            } else {
                this.isEditing = false;
            }
        },

        async getCountries() {
            this.$axios.get(API_ROUTES.GET_COUNTRIES)
            .then(res => {
                if (res.data?.errors?.length >= 1) {
                    const errorMessages = res.data.errors.map(error => error.errorMessage);
                    this.showNotification("error", ...errorMessages);
                }

                this.countries = res.data;
                //this.countrySelected = this.countries[0].id;
            })
            .catch(e => {
                this.showNotification("error", e);
            })
        },

        async updateUser() {
            // console.log(this.userData);
            this.showOverlay = true;
            let isValid = await this.validateFields();
            
            if (isValid) {
                //console.log(this.userData.data);
                this.$axios.put(API_ROUTES.POST_USER, this.userData.data)
                .then(res => {
                    // console.log(res.data?.data?.errors);
                    if (res.data?.data?.errors?.length >= 1) {
                        const errorMessages = res.data.data.errors.map(error => error.errorMessage);
                        this.showNotification("error", ...errorMessages);
                    } else {
                        this.isEditingPersonnelData = false;
                        this.isEditingContactData = false;
                        this.isEditing = false;
                        
                        this.showNotification("success", "Se actualizó correctamente tu información personal");
                    }
                })
                .catch(e => {
                    this.showNotification("error", e);
                })
                .finally(e => {
                    this.showOverlay = false;
                })
            } else {
                this.showOverlay = false;
            }
        },

        async validateFields() {
            let result = true;

            if (this.userData.data.name === "") {
                this.errorNameRequired = true;
                result = false;
            } else {
                this.errorNameRequired = false;
            }
            
            if (this.userData.data.lastName === "") {
                this.errorLastNameRequired = true;
                result = false;
            } else {
                this.errorLastNameRequired = false;
            }
            
            // if (this.userData.data.cellPhone === "") {
            //     this.errorCellPhoneRequired = true;
            //     result = false;
            // } else {
            //     this.errorCellPhoneRequired = false;
            // }

            // if (this.user.birthDate === "") {
            //     this.errorBirthDateRequired = true;
            //     result = false;
            // }

            if (this.userData.data.countryId === 0) {
                this.errorCountryIdRequired = true;
                result = false;
            } else {
                this.errorCountryIdRequired = false;
            }

            if (this.userData.data.email === "") {
                this.errorEmailRequired = true;
                result = false;
            } else {
                this.errorEmailRequired = false;
            }

            if (this.userData.data.password === "") {
                this.errorPasswordRequired = true;
                result = false;
            } else if (this.userData.data.password.length > 0 && this.userData.data.password.length < 6) {
                this.errorPasswordRequired = false;
                this.invalidPassword = true;
                result = false;
            } else {
                this.errorPasswordRequired = false;
                this.invalidPassword = false;
            }
            
            return result;
        },

        showNotification(type, text) {
            this.$toasted.show(text, {
                duration: 5000,
                type: type,
                theme: "bubble",
                singleton: true,
                position: window.innerWidth < 768 ? 'bottom-center' : 'top-right',
                action: {
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                },
            });
        },
    },

    computed: { 
        ...mapGetters(['getUserData']),

        userData() {
            return this.getUserData;
        },
    },

    watch: { 
        "countrySelected": function(newValue) {
            this.userData.data.countryId = newValue;
        },

        "genderSelected": function(newValue) {
            this.userData.data.genderId = newValue;
        }

        // dueDate(newVal) {
        //     if (newVal.length === 2 && newVal.charAt(1) !== '/') {
        //         this.dueDate = newVal + '/';
        //     }
        // }
    }
}
</script>